module.exports = __webpack_public_path__ + "img/FI08615974.74dec255.png";